import { mapGetters, mapState } from 'vuex'
import { MODULE_NAME, GETTERS } from '@/store/filters/constants'
import { MODULE_NAME as MODULE_NAME_CAMPAIGNS } from '@/store/campaigns/constants'

import filterUtils from '@/mixins/filterUtils'

export default {
  name: 'Filters',
  mixins: [
    filterUtils
  ],
  components: {
    FilterGroup: () => import(/* webpackChunkName: "FilterGroup" */ './filter-group/FilterGroup.vue')
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapGetters(MODULE_NAME, {
      groups: GETTERS.GET_GROUPS,
      filters: GETTERS.GET_FILTERS
    }),
    ...mapState(MODULE_NAME_CAMPAIGNS, {
      campaignsMeta: 'meta'
    }),
    campaignsLoading () {
      return this.campaignsMeta.loading || false
    },
    filterCount () {
      const filters = this.selectedGroups.map(g => g.filters).flat()
      return this.getActiveCount(filters)
    },
    selectedGroups () {
      const routeData = this.$route.matched.find(m => m.meta.filterGroups)
      const groups = routeData ? routeData.meta.filterGroups : ['shops', 'campaigns']
      return this.groups.filter(g => groups.indexOf(g.value) !== -1)
    }
  },
  methods: {
    onFilterGroupChange (filter) {
      this.$refs.scrollbar.update()
    },
    onFilterGroupToggle () {
      window.setTimeout(() => {
        this.$refs.scrollbar.update()
      }, 300)
    },
    toggle (value) {
      this.open = value
      this.$emit('toggle')
    },
    tryClose () {
      if (this.open) {
        this.toggle(false)
      }
    },
    enter (element) {
      element.style.height = 'auto'
      const height = getComputedStyle(element).height
      element.style.height = 0
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = height })
      setTimeout(() => { this.$refs.scrollbar.update() }, 300)
    },
    afterEnter (element) {
      element.style.height = 'auto'
    },
    leave (element) {
      const height = getComputedStyle(element).height
      element.style.height = height
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = 0 })
    }
  },
  watch: {}
}
